export enum GPSState {
  FIXED,
  INACTIVE,
  UNAVAILABLE,
}
